import script from "./SidebarCountrySwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./SidebarCountrySwitcher.vue?vue&type=script&setup=true&lang=js"

import "./SidebarCountrySwitcher.vue?vue&type=style&index=0&id=77e2bc66&lang=css"

const __exports__ = script;

export default __exports__